import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toNumber',
})
export class ToNumberPipe implements PipeTransform {
  transform(value: string | number): 'null' | 'green-sla' | 'red-sla' | 'orange-sla' {
    if (value === null || value === undefined || value === '') {
      return 'null';
    }
    const num = Number(value);

    if (isNaN(num)) return 'null';
    if (num > 8) return 'green-sla';
    if (num < 0) return 'red-sla';
    return 'orange-sla';
  }
}
